module.exports = function() {
	return new Worker(__webpack_public_path__ + "ac164a7c6ec13e71d240.soil.jobs.wrkr.js");
};